import React,{useState} from 'react'
import SideBar from '../Components/MainDashboardComp/SideBar';
import DashBoardHeader from '../Components/MainDashboardComp/DashBoardHeader';
import FaqList from '../Components/FaqComp/FaqList';
import MainDashBoard from './MainDashBoard';

const Faq = () => {
    const [show,setShow]= useState(false);
    return (
        <>
            <MainDashBoard>
           <FaqList/>
           </MainDashBoard>
           
        </>
    )
}

export default Faq
